import React, { useState } from 'react';
import Navbar from "./Component/Navbar";
import AllRoutes from './Pages/AllRoutes';
import CartPage from './Pages/CartPage';

import Homepage from "./Pages/Homepage";
import ProductPage from "./Pages/ProductPage";


function App() {

  return (
    <>
  
 
    <AllRoutes/>
 {/* <CartPage/> */}
 

 


    </>
  )
  
}

export default App;
